import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export enum ResultatAnnulerRendezvous {
  Oui,
  Non
}

@Component({
  selector: 'app-dialog-annuler-rendezvous',
  templateUrl: './dialog-annuler-rendezvous.component.html',
  styleUrls: ['./dialog-annuler-rendezvous.component.scss'],
  standalone: false
})
export class DialogAnnulerRendezvousComponent {
  constructor(public dialogRef: MatDialogRef<DialogAnnulerRendezvousComponent>) {}

  confirm() {
    this.dialogRef.close(ResultatAnnulerRendezvous.Oui);
  }

  close() {
    this.dialogRef.close();
  }
}
